import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const RecurringBadge = () => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'yourSessions' });

  return (
    <div className='flex items-center gap-1'>
      <RefreshCw size={16} aria-hidden className='text-text-brand-primary' />
      <span className='text-body-s-regular text-text-default-secondary'>{t('recurring')}</span>
    </div>
  );
};
